/**
 * Flat conic-gradient utilisation donut (Aayuv DS overview spec): solid ring,
 * hairline gray track, white inner circle with a mono percentage.
 * Percent/color are runtime data, so the gradient must be an inline style.
 */
const DonutRing = ({
  percent = 0,
  size = 64,
  thickness = 9,
  color = '#1D6FA4',
  trackColor = '#E5E7EB',
  centerLabel,
  className = '',
  ariaLabel,
}) => {
  const pct = Math.max(0, Math.min(100, Math.round(Number(percent) || 0)));
  const inner = size - thickness * 2;

  return (
    <div
      className={`relative inline-flex shrink-0 items-center justify-center rounded-full ${className}`}
      style={{ width: size, height: size, background: `conic-gradient(${color} 0% ${pct}%, ${trackColor} ${pct}% 100%)` }}
      role='img'
      aria-label={ariaLabel || `${pct}%`}
    >
      <div
        className='flex flex-col items-center justify-center rounded-full bg-white text-center'
        style={{ width: inner, height: inner }}
      >
        {centerLabel ?? (
          <span className='font-jetbrains-mono text-xs font-semibold tabular-nums text-gray-900'>{pct}%</span>
        )}
      </div>
    </div>
  );
};

export default DonutRing;
